import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IconButton, Switch, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Collapse, Box, Fab, FormControlLabel, Skeleton, Alert, Typography } from "@mui/material";
import { Delete, Edit, Description, KeyboardArrowDown, KeyboardArrowUp, Construction, QrCode2} from '@mui/icons-material';
import { InfoTotal, Pagination } from "../Tools";
import { modalConfirm, modalEdit } from "../../features/modal/modalSlice";
import { changeState, loadNextPage, changeStateConstacy, changePageAllEvents } from "../../features/events/eventsSlice";
import { lightGreen } from "@mui/material/colors";
import QRCode from 'react-qr-code';
import { createFile } from "../../features/download/downloadSlice";

const host = process.env.REACT_APP_HOST_NAME;

const Row = ({ row, navigate, stateEvent, dispatch, stateConstancy, isSending, isRoot }) => {
    const [open, setOpen] = React.useState(false)
    const { id, area, clave, nombre, responsable, tipo, fecha, hora, lugar, otroLugar, duracion, isActive, sede, ods, modalidad, tematica, constancy } = row;
    return(
        <React.Fragment>
            <TableRow sx={{ border: isActive > 0 ? `2px solid ${lightGreen[500]}` : 'none' }}>
                {isRoot && <TableCell><b>{area}</b></TableCell> }
                <TableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        { open ? <KeyboardArrowUp /> : <KeyboardArrowDown /> }
                    </IconButton>
                </TableCell>
                <TableCell><b>{id}</b></TableCell>
                <TableCell><b>{clave}</b></TableCell>
                <TableCell>{nombre}</TableCell>
                <TableCell>{responsable}</TableCell>
                <TableCell>{tipo}</TableCell>
                <TableCell>{fecha}</TableCell>
                <TableCell>{hora}</TableCell>
                <TableCell align="center">{duracion}</TableCell>
                <TableCell>{lugar ? lugar : otroLugar}</TableCell>
                <TableCell>{ods}</TableCell>
                <TableCell>{modalidad}</TableCell>
                <TableCell>{tematica}</TableCell>
                <TableCell>{sede}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell sx={{ paddingBottom: 0, paddingTop: 0 }} colSpan={13}>
                    <Collapse in={open} timeout={'auto'} unmountOnExit>
                        <Box sx={{ margin: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            { isActive 
                            ? 
                                <QRCode 
                                    onClick={() => createFile('qr', { id: id }, dispatch, true)}  
                                    value={`${host}/registro/evento/${btoa(id)}`} 
                                    style={{ height: '10em', cursor: 'pointer' }} 
                                />
                            : null }
                            <FormControlLabel control={
                                <Switch
                                    disabled={isSending}
                                    color="success"
                                    value={isActive ? 'on' : 'off'}
                                    checked={!!isActive}
                                    onChange={(e) => stateEvent(e, id)}
                                />}
                                label={ isActive ? 'Activo' : 'Inactivo' } 
                            /> 

                            <Fab color="primary" onClick={() => dispatch(modalEdit(id))}>
                                <Edit />
                            </Fab>
                            

                            <Fab variant="extended" color="info" onClick={() => navigate(`/eventos/${id}`)}>
                                <Description sx={{ mr: 1 }} />
                                Detalles
                            </Fab>

                            <Fab color="error" onClick={() => dispatch(modalConfirm({ id, item: nombre }))}>
                                <Delete />
                            </Fab>
                            
                            <FormControlLabel control={
                                <Switch
                                disabled={isSending}
                                color="primary"
                                value={constancy ? 'on' : 'off'}
                                checked={!!constancy}
                                onChange={(e) => stateConstancy(e, id)}
                                />}
                                label={ constancy > 0 ? 'Constancia individual' : 'Sin constancia individual' } 
                            />
                            
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    )
}

const numberOfPages = (total, size) => Math.ceil(total/size);

const Content = ({ isRoot }) => {
    const { isLoading, isSending } = useSelector(state => state.progress);
    const { currentPage, events, rows, size } = useSelector(state => state.events)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [page, setPage] = React.useState(currentPage);
    const [rowsPerPage, setRowsPerPage] = React.useState(size)
    const pages = React.useMemo(() => numberOfPages(rows, rowsPerPage), [rowsPerPage, rows]);

    const handleChangePage = (event, next) => {
        setPage(next);
        if(isRoot) dispatch(changePageAllEvents({ page: next+1, size: rowsPerPage }))
        else dispatch(loadNextPage({ page: next+1, size: rowsPerPage }))
    }
    const handleChangeRowsPerPage = (event) => {
        let size = +event.target.value;
        setRowsPerPage(size);
        setPage(0);
        if(isRoot) dispatch(changePageAllEvents({ page: 1, size }))
        else dispatch(loadNextPage({ page: 1, size }))
    }
    const stateEvent = (e, id) => dispatch(changeState({ id, state: e.target.checked })) 
    const stateConstancy = (e, id) => dispatch(changeStateConstacy({ id, state: e.target.checked })) 
    const titles = [<Construction />, 'Id', 'Clave', 'Nombre', 'Ponente o Responsable', 'Tipo', 'Fecha', 'Hora', 'Duración', 'Lugar', 'ODS', 'Modalidad', 'Temática', 'Sede'];
    if (isRoot) titles.unshift('Área')
    
    return(
        <TableContainer>
            <InfoTotal num={rows} />
            <Box display={'flex'} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="caption">Página <b>{page+1}</b> de <b>{pages}</b></Typography>
                <Typography variant="caption" color={'primary'}><b>Para descargar el QR, da click sobre la imagen </b> <QrCode2 /></Typography>
            </Box>
            { isLoading ? <Skeleton animation='wave' height={200} /> : rows ? (
                <Table>
                    <TableHead>
                        <TableRow>
                            { titles.map((t, i) => <TableCell key={i}>{t}</TableCell>) }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        { events.map((row, i) => <Row key={i} row={row} navigate={navigate} dispatch={dispatch} stateEvent={stateEvent} stateConstancy={stateConstancy} isSending={isSending} isRoot={isRoot} />)}
                    </TableBody>
                    <Pagination
                        rows={rows}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Table>
            ) : <Alert severity="warning">No se econtraron resultados</Alert> }
        </TableContainer>
    )
}

export default Content;